import { useState, useEffect } from 'react';

const useMediaQuery = query => {
  const queries = Array.isArray(query) ? query : [query];

  const [value, setValues] = useState(() =>
    queries.map(q => window.matchMedia(q).matches),
  );

  const onMediaQueryChange = index => event => {
    setValues(prev => {
      const newValue = prev.slice();
      newValue[index] = event.matches;
      return newValue;
    });
  };

  useEffect(
    () => {
      const mediaQueryLists = queries.map(q => window.matchMedia(q));

      mediaQueryLists.forEach((mediaQueryList, index) => {
        const handler = onMediaQueryChange(index);
        if (typeof mediaQueryList.addListener === 'function') {
          mediaQueryList.addListener(handler);
        } else {
          mediaQueryList.addEventListener('change', handler);
        }
      });

      return () => {
        mediaQueryLists.forEach((mediaQueryList, index) => {
          const handler = onMediaQueryChange(index);
          if (typeof mediaQueryList.removeListener === 'function') {
            mediaQueryList.removeListener(handler);
          } else {
            mediaQueryList.removeEventListener('change', handler);
          }
        });
      };
    },
    [query],
  );

  return value;
};

export default useMediaQuery;
